<template>
  <div id="pmlst">
    <selection-tool
      :loadingtext="loadingtext"
      :titlebar="titlebar"
      :errortext="errortext"
      :showtextpane="showtextpane"
    />
  </div>
</template>

<script>
import SelectionTool from '@/views/SelectionTool'

export default {
  name: 'app',
  components: { SelectionTool },
  data() {
    return {
      /**
       * Text for the loading screen.
       */
      loadingtext:
        'One moment, please. The MONISTAT® Symptom Checker is loading.',
      /**
       * The markup to use for the title inside the title bar.
       */
      titlebar: '<div class="image"></div>',
      /**
       * The text to use if things go wrong and we end up in the error state.
       */
      errortext: "We're sorry, an error occurred. Please try again later.",
      /**
       * Should the questions show a text pane of supplemental information
       * while going through the question process.
       */
      showtextpane: true
    }
  }
}
</script>

<style lang="scss">
/**
 * This file holds configuration settings for use with the breakpoint
 * module for writing CSS.
 */
@import 'style/sass-config';
$purple: #9e2b91;
$blue_light: #82d3ef;
$blue_dark: #0e1d49;
$grey_light: #ccc;
$grey_med: #888;
$grey_text: #333;
$disclaimer_text: #666;
html,
body {
  font-size: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
#pmlst {
  color: #666;
  font-family: Helvetica, Arial, sans-serif;
  line-height: 1.25em;
  margin: 0 -7.5px;
  @include breakpoint($medium) {
    margin: 0;
  }
  button {
    cursor: pointer;
    margin: 0;
    padding: 0;
    &:focus,
    &:active {
      outline: none;
    }
  }
  img {
    height: auto;
    max-width: 100%;
  }
  .actions {
    border-top: 1px solid rgba(255, 255, 255, 0.75);
    line-height: 1rem;
    margin: 0 -1rem -1rem;
    padding: 1rem;
    text-align: right;
    button {
      border: none;
      background-color: transparent;
      color: $blue_dark;
      font-size: 1rem;
      margin-left: 0.5rem;
      i {
        color: #fff;
        margin-right: 0.25rem;
        opacity: 0.75;
      }
    }
  }
}
#pmlst-main {
  margin: 0 auto;
  max-width: 75rem; // @todo: match this to real stuff.
}

#pmlst-loading {
  text-align: center;
}
#pmlst-startup {
  background-color: $blue_light;
  border-bottom: 1px solid $grey_light;
  color: $blue_dark;
  margin: 0;
  padding: 1rem;
  text-align: center;
  @include breakpoint($xlarge) {
    position: relative;
    &:before,
    &:after {
      background-color: $blue_light;
      border-bottom: 1px solid $grey_light;
      border-top: 1px solid $grey_light;
      bottom: -1px;
      content: '';
      position: absolute;
      top: -1px;
      width: 1000px;
    }
    &:before {
      right: 100%;
    }
    &:after {
      left: 100%;
    }
  }
  .pmlst-startup-wrapper {
    background-color: $blue_dark;
    border-radius: 1rem;
    margin: 3rem auto 0;
    max-width: 700px;
    padding: 1rem;
    @include breakpoint($medium) {
      margin-bottom: 1rem;
    }
  }
  .image {
    background-image: url(./assets/logo-symptomchecker.svg);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: contain;
    height: 105px;
  }
  .pmlst-startup-extra-wrapper {
    background-color: #fff;
    padding: 1rem 1rem 1rem;
    position: relative;
    &:before {
      background-image: url(./assets/bg-clip.png);
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: contain;
      content: ' ';
      height: 80px;
      left: 50%;
      margin-left: -125px;
      position: absolute;
      top: -70px;
      width: 250px;
    }
  }
  .text-wrap {
    box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.25);
    color: $grey_med;
    margin: 2rem -1rem -1rem;
    padding: 1rem;
    @include breakpoint($medium) {
      padding: 2rem;
    }
  }
}
#pmlst-titlebar {
  background-color: #fff;
  padding: 1rem;
  text-align: center;
  .image {
    background-image: url(./assets/logo-symptomchecker.svg);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: contain;
    height: 105px;
  }
}
#pmlst-quiz {
  border-bottom: 1px solid $grey_light;
  border-top: 1px solid $grey_light;
  @include breakpoint($xlarge) {
    position: relative;
    &:before,
    &:after {
      border-bottom: 1px solid $grey_light;
      border-top: 1px solid $grey_light;
      bottom: -1px;
      content: '';
      position: absolute;
      top: -1px;
      width: 1000px;
    }
    &:before {
      background-color: #fff;
      // border-right: 1px solid $grey_light;
      right: 100%;
    }
    &:after {
      background-color: $blue_light;
      // border-left: 1px solid #fff;
      left: 100%;
    }
  }
  .pmlst-quiz-wrapper {
    @include breakpoint($medium) {
      display: flex;
      align-items: center;
    }
    & > div {
      box-sizing: border-box;
      padding: 1rem;
      @include breakpoint($medium) {
        flex: 1;
      }
      &:first-child {
        background-color: #fff;
      }
      &:last-child {
        background-color: $blue_light;
        @include breakpoint($medium) {
          min-height: 470px;
        }
      }
    }
  }
}
#pmlst-textpane {
  .textpane-item-wrapper {
    align-items: center;
    display: flex;
    & > div {
      &.icon {
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: contain;
        // height: 128px;
        // width: 128px;
        height: 50px;
        width: 50px;
        flex: 0 0 auto;
        margin: 0 1rem 0 0;
        @include breakpoint($medium) {
          height: 120px;
          margin: 0 0 2rem;
          width: 120px;
        }
        &.icon-itch {
          background-image: url(./assets/icon-itch.svg);
        }
        &.icon-discharge {
          background-image: url(./assets/icon-discharge.svg);
        }
        &.icon-odor {
          background-image: url(./assets/icon-odor.svg);
        }
      }
      &.text {
        flex: 1;
        p {
          margin: 0;
        }
      }
    }
    @include breakpoint($medium) {
      flex-direction: column;
      .icon {
        margin-bottom: 2rem;
        text-align: center;
        img {
          height: 8rem;
          width: 8rem;
        }
      }
    }
  }
}
#pmlst-steptracker {
  margin-bottom: 1rem;
  text-align: center;
  .pmlst-steptracker-wrapper {
    padding: 0;
    @include breakpoint($medium) {
      padding: 1rem;
    }
  }
  progress {
    background-color: #fff;
    border: none;
    border-radius: 0.25rem;
    display: block;
    height: 0.5rem;
    margin: 0 auto;
    overflow: hidden;
    width: 50%;
    -webkit-appearance: none;
    // Background...
    &::-webkit-progress-bar {
      background-color: #fff;
    }
    // Value/fill...
    // (browser specific per browser, cannot be combined)
    &::-webkit-progress-value {
      background-color: $purple;
      border-radius: 0.25rem;
    }
    &::-moz-progress-bar {
      background-color: $purple;
      border-radius: 0.25rem;
    }
    &::-ms-fill {
      background-color: $purple;
      border-radius: 0.25rem;
    }
  }
}
#pmlst-questions {
  @include breakpoint($medium) {
    padding-bottom: 4rem !important;
    position: relative;
    .actions {
      bottom: 1rem;
      left: 1rem;
      position: absolute;
      right: 1rem;
      @include breakpoint($xlarge) {
        &:after {
          border-top: 1px solid rgba(255, 255, 255, 0.75);
          content: '';
          height: 1rem;
          left: 100%;
          position: absolute;
          top: -1px;
          width: 1000px;
          z-index: 3;
        }
      }
    }
  }
}
#pmlst-outcome {
  background-color: $blue_light;
  border-bottom: 1px solid $grey_light;
  padding: 1rem;
  @include breakpoint($xlarge) {
    position: relative;
    &:before,
    &:after {
      background-color: $blue_light;
      border-bottom: 1px solid $grey_light;
      border-top: 1px solid $grey_light;
      bottom: -1px;
      content: '';
      position: absolute;
      top: -1px;
      width: 1000px;
    }
    &:before {
      right: 100%;
    }
    &:after {
      left: 100%;
    }
  }
  .pmlst-outcome-extra-wrapper {
    background-color: $blue_dark;
    border-radius: 1rem;
    margin: 3rem auto 0;
    max-width: 700px;
    padding: 1rem;
    @include breakpoint($medium) {
      margin-bottom: 1rem;
    }
    & > div {
      background-color: #fff;
      padding: 1rem;
    }
    & > div:first-child {
      position: relative;
      &:before {
        background-image: url(./assets/bg-clip.png);
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: contain;
        content: ' ';
        height: 80px;
        left: 50%;
        margin-left: -125px;
        position: absolute;
        top: -70px;
        width: 250px;
      }
    }
    .actions {
      border-top: 1px solid $grey_light;
      margin: 0;
      i {
        color: $blue_light;
      }
    }
  }
}
.outcome-item {
  margin: -1rem;
  .outcome-item-main {
    background-color: #eee;
    padding: 2rem 1rem;
    text-align: center;
    @include breakpoint($medium) {
      padding: 2rem;
    }
    .outcome-item-main-wrapper {
      background-color: #fff;
      border-radius: 1rem;
      box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
      padding: 1rem;
    }
    .intro,
    .thanks {
      color: $grey_med;
    }
    .intro-description {
      margin-bottom: 1rem;
    }
    h3 {
      color: $blue_dark;
      font-size: 1.25rem;
      line-height: 1.25em;
      margin: 1rem 0;
      @include breakpoint($medium) {
        font-size: 1.5rem;
      }
      i {
        color: $purple;
      }
    }
    .button-wrapper {
      margin-bottom: 1rem;
    }
    a.button {
      background-color: $purple;
      border-radius: 1rem;
      color: #fff;
      display: inline-block;
      font-size: 1.25rem;
      padding: 1rem 2rem;
      text-decoration: none;
    }
  }
  .outcome-item-cta {
    padding: 1rem;
    text-align: center;
    .product-image {
      margin-bottom: 1rem;
    }
  }
  .symptom-checker {
    img {
      max-width: 360px !important;
    }
  }
}
#pmlst-disclaimers {
  font-size: 0.75rem;
  color: $disclaimer_text;
  padding: 1rem 1rem;
  text-align: center;
}

button.start {
  border: none;
  background-color: $purple;
  border-radius: 1rem;
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 1rem 2rem !important;
  &:after {
    content: '\f105';
    font-family: 'Font Awesome 5 Free', 'FontAwesome';
    font-weight: 900;
    margin-left: 0.5rem;
    vertical-align: baseline;
  }
}

// Question list
ol.pmlst-questionlist-list {
  list-style: none;
  margin: 0;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column-reverse;
  // @include breakpoint($medium) {
  //   flex-direction: column;
  // }
  & > li {
    margin: 0;
    opacity: 0.5;
    padding: 0;
    position: relative;
    transition: opacity 0.5s;
    &:hover {
      @include breakpoint($medium) {
        opacity: 1;
      }
    }
    &:last-child {
      background-color: $purple;
      margin: -0.5rem -1rem 0.5rem;
      opacity: 1;
      padding: 0.5rem 1rem;
      @include breakpoint($medium) {
        margin: 0.5rem -1rem 0;
      }
      @include breakpoint($xlarge) {
        border-bottom-right-radius: 1.5rem;
        border-top-right-radius: 1.5rem;
      }
      &:before {
        border: 0.5rem solid transparent;
        border-left-color: #fff;
        content: '';
        position: absolute;
        left: 0.25rem;
        margin-top: -0.5rem;
        top: 50%;
      }
      .qi-wrapper {
        border-color: $purple;
        .qi-text {
          color: $blue_dark;
        }
        button.response:hover {
          color: $purple;
        }
      }
    }
  }
}
// Individual question
.qi-wrapper {
  align-items: center;
  background-color: #fff;
  border: 3px solid $grey_med;
  border-radius: 1rem;
  display: flex;
  margin: 0.5rem 0 0.5rem 1rem;
  padding: 0.25rem 1rem;
  & > div {
    box-sizing: border-box;
    margin: -0.25rem 0;
    &.qi-text {
      color: $grey_med;
      flex: 2;
      padding: 0.5rem 0.5rem 0.5rem 0;
    }
    &.qi-options {
      border-left: 1px solid $grey_light;
      flex: 1;
    }
  }
  .qi-options {
    ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      & > li {
        box-sizing: border-box;
        flex: 1;
        padding-left: 0.5rem;
        text-align: center;
      }
    }
  }
}
button.response {
  background-color: transparent;
  border: none;
  color: #ccc;
  font-size: 1.25rem;
  @include breakpoint($medium) {
    font-size: 2rem;
  }
}
ol.pmlst-questionlist-list > li:last-child {
  button.response {
    color: $grey_med;
  }
}
button.response-active {
  color: $grey_med;
}
// Special single-question override
#pmlst-q-3 {
  .qi-wrapper {
    display: block;
    .qi-text {
      margin-top: -0.25rem;
      padding: 0.5rem;
      text-align: center;
    }
    .qi-options {
      margin: 0 -1rem -0.25rem;
      border-top: 1px solid $grey_light;
      border-left: none;
      text-align: center;
      ul {
        margin: 0;
        padding: 0;
        li {
          border-left: 1px solid $grey_light;
          padding: 0.5rem;
          &:first-child {
            border-left: none;
          }
        }
      }
    }
  }
  button.response {
    font-size: 1rem;
    font-weight: bold;
  }
}

/**
 * Animations and transitions...
 */
// Application loading animation
.pmlst-loader {
  .animation {
    border: 0.5rem solid $blue_light;
    border-top: 0.5rem solid $purple;
    border-radius: 50%;
    margin: 2rem auto;
    width: 3rem;
    height: 3rem;
    animation: loaderanim 1s linear infinite;
  }
  .text {
    font-size: 0.75rem;
    margin-bottom: 2rem;
  }
}
@keyframes loaderanim {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
// end of application loading animation

// Transition applied to questions when they're added to the page...
.question-enter {
  opacity: 0;
}
.question-enter-to {
  opacity: 1;
}
.question-enter-active {
  transition: opacity 1s ease;
}

.question-leave-to,
.question-leave,
.question-leave-active {
  display: none;
}

// Transition applied to application state panes when changing on the page...
.pane-enter,
.pane-leave-to {
  opacity: 0;
}
.pane-enter-to,
.pane-leave {
  opacity: 1;
}
.pane-enter-active,
.pane-leave-active {
  transition: opacity 0.5s ease;
}
</style>
